import { Container, Heading, Box, Flex } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

import { ISectionProps, Section } from '@/components/ui/core/Section/Section';

interface IOriginalSectionProps extends ISectionProps {
  title: string;
  subheading?: ReactNode;
}

export const OriginalsSection: FC<IOriginalSectionProps> = ({ title, children, subheading, ...rest }) => {
  return (
    <Section {...rest}>
      <Container py={10}>
        <Flex mb="6" alignItems="flex-end" justifyContent="space-between">
          <Heading fontSize={{ base: '4xl', md: '5xl' }}>{title}</Heading>
          {subheading}
        </Flex>
        <Box>{children}</Box>
      </Container>
    </Section>
  );
};
